import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CustomPaginatorIntl extends MatPaginatorIntl {
  ofElement = 'of';

  constructor(private translate: TranslateService) {
    super();
    this.translate.get('PAGINATOR.ITEMS_PER_PAGE').subscribe((res: string) => {
      this.itemsPerPageLabel = res;
    });
    this.translate.get('PAGINATOR.NEXT_PAGE').subscribe((res: string) => {
      this.nextPageLabel = res;
    });
    this.translate.get('PAGINATOR.PREVIOUS_PAGE').subscribe((res: string) => {
      this.previousPageLabel = res;
    });
    this.translate.get('PAGINATOR.OF_ELEMENT').subscribe((res: string) => {
      this.ofElement = res;
    });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    const max = page * pageSize + pageSize;
    return page * pageSize + 1 + ' - ' + (length > max ? max : length) + ' ' + this.ofElement + ' ' + length;
  }
}
